var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VpConfirmModal',{attrs:{"modalId":"quickpassConfirmModal"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('p',{staticClass:"vp-font-weight-700"},[_vm._v(" "+_vm._s(_vm.$t("users.form.printQuickpass"))+" ")])]},proxy:true},{key:"text1",fn:function(){return [_c('span',{domProps:{"innerHTML":_vm._s(
        _vm.$t('users.form.checkKiosk', {
          kiosk: _vm.getModalInfo.selectedKiosk || 'kiosk',
        })
      )}})]},proxy:true},{key:"buttons",fn:function(){return [_c('VpButton',{attrs:{"text":_vm.$t('common.okay')},on:{"click":_vm.onSubmit}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }